<template>
  <div>
    <H2>QR Code Scanner</H2>
    <v-btn
      color="primary"
      @click="startScan"
    >
      Scan
    </v-btn>
    <v-btn
      class="ml-2"
      color="secondary"
      @click="stoptScan"
    >
      Stop
    </v-btn>
    <div id="qr-code-full-region"></div>
    <div v-if="debug">
      {{ debugMessage }}
    </div>
  </div>
</template>
<script>
import { Html5QrcodeScanner, Html5QrcodeScanType, Html5Qrcode } from 'html5-qrcode'

export default {
  name: 'QrcodeScanner',
  props: {
    qrbox: {
      type: Number,
      default: 250,
    },
    fps: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      debug: false,
      debugMessage: 'test',
      devices: [],
      cameraId: '',
      html5QrCode: null,
    }
  },
  mounted() {
    // // This method will trigger user permissions
    Html5Qrcode.getCameras().then(devices => {
      console.log('devices', devices)
      this.devices = devices

      /**
       * devices would be an array of objects of type:
       * { id: "id", label: "label" }
       */
      if (devices && devices.length) {
        // var cameraId = devices[0].id;
        // console.log('cameraId', cameraId)
        devices.forEach(device => {
          if (device.label.includes('back')) {
            this.cameraId = device.id
          }
        })
        if (!this.cameraId) {
          // alert("back camera not found.")
          this.cameraId = devices[0].id
        }
      }
    }).catch(err => {
      // handle err
    })
    this.html5QrCode = new Html5Qrcode('qr-code-full-region')

    // const config = {
    //   fps: this.fps,
    //   qrbox: this.qrbox,
    //   // Only support camera scan type.
    //   supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
    // };
    // let html5QrcodeScanner = new Html5QrcodeScanner(
    //   'qr-code-full-region',
    //   config,
    //   /* verbose= */ false);
    // html5QrcodeScanner.render((text,result)=>{
    //   console.log("text,result",text,result)
    //   this.onScanSuccess(text,result)
    // }, this.onScanFailure);
  },
  methods: {
    startScan() {
      this.log('QR Code scanning is started.')
      const config = {
        fps: this.fps,
        qrbox: this.qrbox,

        // Only support camera scan type.
        supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
      }
      this.html5QrCode.start({ facingMode: 'environment' }, config, (text, result) => {
        console.log('text,result', text, result)
        this.onScanSuccess(text, result)
      })
    },
    stoptScan() {
      this.html5QrCode.stop().then(ignore => {
        // QR Code scanning is stopped.
        console.log('QR Code scanning is stopped.')
        this.log('QR Code scanning is stopped.')
      }).catch(err => {
        // Stop failed, handle it.
      })
    },
    log(target) {
      this.debugMessage += `${JSON.stringify(target, null, 4)}\n`
    },
    onScanSuccess(decodedText, decodedResult) {
      this.log(decodedText)

      // this.log(decodedResult)
      this.$emit('result', decodedText, decodedResult)
    },
    onScanFailure(error) {
      // this.log(error)
    },
  },
}
</script>

<style>
</style>
